import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const invitationToApplyForConnectOpportunityRoute: RouteConfig<'with-page'> = {
    name: 'Invitation to Apply for Connect Opportunity',
    path: '/work-opps/invitation/:workOppId',
    context: 'member',
    page: lazy(() => import('.')),
    flags: ['member-route']
}